/** Pipálható autó jellemzők — feltöltés és megjelenítés. */
export const CAR_FEATURE_GROUPS = [
  {
    id: "papers",
    label: "Okmányok és dokumentumok",
    items: [
      { key: "paper_registration", label: "Érvényes forgalmi engedély" },
      { key: "paper_service_book", label: "Szervizkönyv / szerviztörténet" },
      { key: "paper_invoice", label: "Számla / vételi szerződés" },
      { key: "paper_keys", label: "Minden kulcs megvan (2+)" },
      { key: "paper_tuv", label: "Érvényes műszaki vizsga" },
      { key: "paper_warranty", label: "Garancia (gyári vagy kereskedői)" },
      { key: "paper_no_finance", label: "Nincs hátralévő hitel / zálog" },
    ],
  },
  {
    id: "tech",
    label: "Műszaki felszereltség",
    items: [
      { key: "equip_ac_manual", label: "Manuális klíma" },
      { key: "equip_ac_auto", label: "Automata klíma" },
      { key: "equip_power_steering", label: "Szervokormány" },
      { key: "equip_electric_windows", label: "Elektromos ablakok" },
      { key: "equip_electric_mirrors", label: "Elektromos tükrök" },
      { key: "equip_sport_seats", label: "Sportülések" },
      { key: "equip_parking_heater", label: "Állófűtés / Webasto" },
      { key: "equip_massage_seats", label: "Masszírozós ülés" },
    ],
  },
  {
    id: "comfort",
    label: "Komfort és belső",
    items: [
      { key: "equip_power_seats", label: "Elektromos ülésállítás" },
      { key: "equip_heated_seats", label: "Fűthető ülés" },
      { key: "equip_ventilated_seats", label: "Szellőztetett ülés" },
      { key: "equip_memory_seats", label: "Memória ülés" },
      { key: "equip_leather", label: "Bőr / valódi bőr belső" },
      { key: "equip_dual_climate", label: "Kétzónás (vagy többzónás) klíma" },
      { key: "equip_heated_wheel", label: "Fűthető kormány" },
      { key: "equip_panoramic_roof", label: "Panoráma / üvegtető" },
      { key: "equip_keyless", label: "Kulcsnélküli nyitás / indítás" },
      { key: "equip_electric_tailgate", label: "Elektromos csomagtérajtó" },
    ],
  },
  {
    id: "safety",
    label: "Biztonság és asszisztensek",
    items: [
      { key: "equip_abs_esp", label: "ABS / ESP" },
      { key: "equip_airbags", label: "Több légzsák" },
      { key: "equip_parking_sensors", label: "Parkolóradar (elöl / hátul)" },
      { key: "equip_rear_camera", label: "Tolatókamera" },
      { key: "equip_360_camera", label: "360° körkamera" },
      { key: "equip_cruise_control", label: "Tempomat" },
      { key: "equip_adaptive_cruise", label: "Távolságtartó tempomat" },
      { key: "equip_lane_assist", label: "Sávelhagyás figyelmeztetés" },
      { key: "equip_blind_spot", label: "Holttérfigyelő" },
      { key: "equip_auto_parking", label: "Automata parkolás" },
    ],
  },
  {
    id: "multimedia",
    label: "Multimédia és navigáció",
    items: [
      { key: "equip_navigation", label: "Gyári / beépített navigáció" },
      { key: "equip_apple_carplay", label: "Apple CarPlay" },
      { key: "equip_android_auto", label: "Android Auto" },
      { key: "equip_bluetooth", label: "Bluetooth telefon / zene" },
      { key: "equip_usb", label: "USB / töltő csatlakozók" },
      { key: "equip_premium_audio", label: "Prémium hangrendszer" },
      { key: "equip_digital_cockpit", label: "Digitális műszerfal" },
      { key: "equip_head_up_display", label: "Head-up display (HUD)" },
    ],
  },
  {
    id: "exterior",
    label: "Külső és hajtás",
    items: [
      { key: "equip_alloy_wheels", label: "Könnyűfém felni" },
      { key: "equip_led_lights", label: "LED / xenon fényszóró" },
      { key: "equip_fog_lights", label: "Ködlámpa" },
      { key: "equip_tow_hitch", label: "Vonóhorog" },
      { key: "equip_awd", label: "Összkerékhajtás (4x4 / AWD)" },
      { key: "equip_sport_package", label: "Sport csomag / M / AMG / RS jelleg" },
      { key: "equip_non_smoker", label: "Nem dohányzó autó" },
      { key: "equip_one_owner", label: "Első tulajdonos (magyar)" },
      { key: "equip_guaranteed_mileage", label: "Garantált km futás" },
      { key: "equip_lady_owner", label: "Hölgy tulajdonostól" },
    ],
  },
  {
    id: "extra",
    label: "Kiegészítő",
    items: [
      { key: "equip_spare_wheel", label: "Pótkerék" },
      { key: "equip_repair_kit", label: "Defektjavító készlet" },
      { key: "equip_roof_rack", label: "Tetőcsomagtartó" },
      { key: "equip_ev_cable", label: "Töltőkábel (EV)" },
    ],
  },
];

const LABEL_MAP = Object.fromEntries(
  CAR_FEATURE_GROUPS.flatMap((g) => g.items.map((i) => [i.key, i.label])),
);

export const ALL_FEATURE_KEYS = new Set(
  CAR_FEATURE_GROUPS.flatMap((g) => g.items.map((i) => i.key)),
);

export function featureLabel(key) {
  return LABEL_MAP[key] || key;
}

export function partitionFeatures(selected = []) {
  const keys = [];
  const custom = [];
  const seenKey = new Set();
  const seenCustom = new Set();
  for (const item of Array.isArray(selected) ? selected : []) {
    if (typeof item !== "string") continue;
    const t = item.trim();
    if (!t) continue;
    if (ALL_FEATURE_KEYS.has(t)) {
      if (!seenKey.has(t)) {
        seenKey.add(t);
        keys.push(t);
      }
    } else if (!seenCustom.has(t)) {
      seenCustom.add(t);
      custom.push(t);
    }
  }
  return { keys, custom };
}

export function groupedSelectedFeatures(selected = []) {
  const { keys, custom } = partitionFeatures(selected);
  const set = new Set(keys);
  const groups = CAR_FEATURE_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((i) => set.has(i.key)),
  })).filter((g) => g.items.length > 0);

  if (custom.length) {
    groups.push({
      id: "custom",
      label: "További felszereltség",
      items: custom.map((label) => ({ key: `custom:${label}`, label })),
    });
  }
  return groups;
}

export function countSelectedFeatures(selected = []) {
  const { keys, custom } = partitionFeatures(selected);
  return keys.length + custom.length;
}

export function sanitizeFeatureKeys(raw) {
  if (!Array.isArray(raw)) return [];
  return [...new Set(raw.filter((k) => ALL_FEATURE_KEYS.has(k)))];
}
